module.exports = __webpack_public_path__ + "static/img/remain-count.40e313f9.svg";